<div class="columns">
  <div class="column is-10 is-offset-1">
    @switch (wizardState) {
      @case ('metadata') {
        <div>
          @if (objectType == ObjectType.Residence || objectType.toString() == 'entireBuilding') {
            <app-entire-building-claim-metadata [claimId]="claimId" (afterClaimCreation)="afterClaimInitiation($event)"/>
          } @else if (objectType == ObjectType.Others || objectType.toString() == 'others') {
            <app-others-claim-metadata [claimId]="claimId" (afterClaimCreation)="afterClaimInitiation($event)"/>
          } @else {
            <app-condominium-claim-metadata [claimId]="claimId" (afterClaimCreation)="afterClaimInitiation($event)"/>
          }
        </div>
      }
      @case ('photos') {
        <app-claim-file-uploads
          [config]="photosDocumentsConfig"
          [claimId]="claimId"
          [presignedUrlSupplier]="claimService.getPresignedUrls.bind(claimService)"
          (filesUploadingChange)="onPhotosFileUploaded($event)">
        </app-claim-file-uploads>
      }
      @case ('submitted') {
        <div>
          <app-submitted-claim-overview [claimId]="claimId" [claimMetadata]="claimMetadata" [objectType]="objectType"/>
        </div>
      }
      @default {
        <div class="message is-warning">{{ 'claimWizard.unexpectedState' | localize }}</div>
      }
    }
  </div>
</div>
